import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-driver',
  templateUrl: './view-driver.component.html',
  styleUrls: ['./view-driver.component.css']
})
export class ViewDriverComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
